import { render } from "./DiagnosisBilling.vue?vue&type=template&id=a6786000&scoped=true"
import script from "./DiagnosisBilling.vue?vue&type=script&lang=js"
export * from "./DiagnosisBilling.vue?vue&type=script&lang=js"

import "./DiagnosisBilling.vue?vue&type=style&index=0&id=a6786000&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6786000"]])

export default __exports__